// Miruna sticky gallery - desktop product page nav arrows
(function () {
  function initMirunaStickyGallery() {
    if (window.innerWidth < 1000) return;

    var gallery = document.querySelector('.product-gallery');
    if (!gallery) return;

    var carousel = gallery.querySelector('.product-gallery__carousel');
    if (!carousel) return;

    var items = Array.from(carousel.querySelectorAll('.product-gallery__media:not([hidden])'));
    if (items.length <= 1) return;

    function buildRows() {
      var rows = [], lastTop = -1;
      items = Array.from(carousel.querySelectorAll('.product-gallery__media:not([hidden])'));
      items.forEach(function (item) {
        var top = item.offsetTop;
        if (top !== lastTop) { rows.push(top); lastTop = top; }
      });
      return rows;
    }

    var rows = buildRows();
    if (rows.length <= 1) return;

    var currentPage = 0;

    var prevBtn = document.createElement('button');
    prevBtn.className = 'miruna-gallery-prev';
    prevBtn.type = 'button';
    prevBtn.setAttribute('aria-label', 'Previous images');
    prevBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>';

    var nextBtn = document.createElement('button');
    nextBtn.className = 'miruna-gallery-next';
    nextBtn.type = 'button';
    nextBtn.setAttribute('aria-label', 'Next images');
    nextBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>';

    gallery.style.position = 'relative';
    gallery.appendChild(prevBtn);
    gallery.appendChild(nextBtn);

    function updateNav() {
      prevBtn.disabled = (currentPage === 0);
      nextBtn.disabled = (currentPage >= rows.length - 1);
    }

    function goTo(page) {
      rows = buildRows();
      currentPage = Math.max(0, Math.min(page, rows.length - 1));
      carousel.scrollTo({ top: rows[currentPage], behavior: 'smooth' });
      updateNav();
    }

    prevBtn.addEventListener('click', function () { goTo(currentPage - 1); });
    nextBtn.addEventListener('click', function () { goTo(currentPage + 1); });

    // Scroll sync - throttled with requestAnimationFrame instead of setTimeout
    var rafPending = false;
    carousel.addEventListener('scroll', function () {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(function () {
        var scrollTop = carousel.scrollTop;
        var closest = 0, minDist = Infinity;
        rows.forEach(function (rowTop, i) {
          var dist = Math.abs(rowTop - scrollTop);
          if (dist < minDist) { minDist = dist; closest = i; }
        });
        currentPage = closest;
        updateNav();
        rafPending = false;
      });
    });

    document.addEventListener('variant:changed', function () {
      setTimeout(function () {
        rows = buildRows();
        currentPage = 0;
        carousel.scrollTo({ top: 0, behavior: 'instant' });
        updateNav();
      }, 300);
    });

    updateNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMirunaStickyGallery);
  } else {
    initMirunaStickyGallery();
  }
})();

// Mobile size chart - table → tap-to-view card UI
(function () {
  function buildSizeCard(table) {
    if (table.dataset.mobilized) return;
    table.dataset.mobilized = '1';

    var headers = Array.from(table.querySelectorAll('thead th')).map(function (th) {
      return th.textContent.trim();
    });
    var rows = Array.from(table.querySelectorAll('tbody tr')).map(function (tr) {
      return Array.from(tr.querySelectorAll('td')).map(function (td) {
        return td.textContent.trim();
      });
    });
    if (!rows.length || headers.length < 2) return;

    var wrap = document.createElement('div');
    wrap.className = 'sc-mobile';

    var tabRow = document.createElement('div');
    tabRow.className = 'sc-mobile__tabs';
    rows.forEach(function (row, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sc-mobile__tab' + (i === 0 ? ' is-active' : '');
      btn.textContent = row[0];
      btn.dataset.sci = i;
      tabRow.appendChild(btn);
    });

    var cardWrap = document.createElement('div');
    cardWrap.className = 'sc-mobile__cards';
    rows.forEach(function (row, i) {
      var card = document.createElement('div');
      card.className = 'sc-mobile__card' + (i === 0 ? ' is-active' : '');
      card.dataset.sci = i;

      var grid = document.createElement('div');
      grid.className = 'sc-mobile__grid';
      for (var j = 1; j < headers.length; j++) {
        var item = document.createElement('div');
        item.className = 'sc-mobile__item';
        item.innerHTML =
          '<span class="sc-mobile__lbl">' + headers[j] + '</span>' +
          '<span class="sc-mobile__val">' + (row[j] || '-') + '</span>';
        grid.appendChild(item);
      }
      card.appendChild(grid);
      cardWrap.appendChild(card);
    });

    tabRow.addEventListener('click', function (e) {
      var btn = e.target.closest('.sc-mobile__tab');
      if (!btn) return;
      var idx = btn.dataset.sci;
      tabRow.querySelectorAll('.sc-mobile__tab').forEach(function (b) { b.classList.remove('is-active'); });
      cardWrap.querySelectorAll('.sc-mobile__card').forEach(function (c) { c.classList.remove('is-active'); });
      btn.classList.add('is-active');
      cardWrap.querySelector('[data-sci="' + idx + '"]').classList.add('is-active');
    });

    wrap.appendChild(tabRow);
    wrap.appendChild(cardWrap);
    table.insertAdjacentElement('afterend', wrap);
    table.style.display = 'none';
  }

  function initMobileSizeCharts() {
    if (window.innerWidth >= 700) return;
    document.querySelectorAll('table.size-chart').forEach(buildSizeCard);
  }

  document.addEventListener('DOMContentLoaded', initMobileSizeCharts);
  document.addEventListener('click', function (e) {
    if (e.target.closest('[aria-controls^="size-chart"]')) {
      setTimeout(initMobileSizeCharts, 150);
    }
  });
})();
